/**
 * 解析 GA cookie，取得 client_id / session_id
 * 供後端 GA4 Measurement Protocol 使用，讓後端事件能歸到同一位使用者與 session，
 * GA4 才能以 transaction_id 去重，避免產生 (direct)/(none) 的重複交易
 */

const GA_SESSION_COOKIE = '_ga_9ECFYDZXXF'; // 對應評估 ID G-9ECFYDZXXF

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : '';
}

export function getGAClientId() {
  // _ga cookie 格式：GA1.1.1234567890.1712345678，client_id 為後兩段
  const parts = getCookie('_ga').split('.');
  return parts.length >= 4 ? `${ parts[2] }.${ parts[3] }` : '';
}

export function getGASessionId() {
  // _ga_XXX cookie 格式：
  //   舊版 GS1.1.<session_id>.<session_number>...
  //   新版 GS2.1.s<session_id>$o<session_number>...
  const parts = getCookie(GA_SESSION_COOKIE).split('.');
  if(parts.length < 3) return '';
  return parts[2].replace(/^s/, '').split('$')[0];
}

export function getGATracking() {
  return {
    gaClientId: getGAClientId(),
    gaSessionId: getGASessionId(),
  };
}
